export const systemLang = 'en' // 'ru' | 'en'
